import { FC, SetStateAction, useEffect, useState } from 'react';
import {
  userServicesColumnData,
  userServicesTableColumnExtensions
} from '../../../utils/mockUpData';
import { CustomTable } from '../../shared';
import { ServicesListTypes } from '../../../panel/Users/UserInfo';
import Status from '../../shared/StatusUtility';
import { CheckSaveIcon, CrossIcon, EditPencilIcon } from '../../../assets/icons';
import { updateUserServiceAPI } from '../../../redux/features/services/servicesSlice';
import { useAppDispatch } from '../../../redux/store';

const Services: FC<{ servicesList: ServicesListTypes[] }> = ({ servicesList }) => {
  // STATES
  const [rowsData, setRowsData] = useState<ServicesListTypes[]>([...servicesList]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [editingIds, setEditingIds] = useState<string[] | null>([]);
  const dataProviders = [
    {
      columnName: ['status'],
      func: (restProps: any) => Status(restProps?.row?.status, 'Active', 'Inactive')
    },
    {
      columnName: ['actions'],
      func: (restProps: any) => (
        <Actions
          restProps={restProps}
          editingIds={editingIds}
          setEditingIds={setEditingIds}
          setRowsData={setRowsData}
        />
      )
    }
  ];
  return (
    <CustomTable
      rows={rowsData?.length > 0 ? rowsData : []}
      columns={userServicesColumnData}
      tableColumnExtensions={userServicesTableColumnExtensions}
      selectedIds={selectedIds}
      setSelectedIds={(selectedIds: SetStateAction<never[]>) => setSelectedIds(selectedIds)}
      dataProviders={dataProviders}
      isRowsEditable={true}
      editingIds={editingIds}
      setEditingIds={setEditingIds}
    />
  );
};
export default Services;

type ActionProps = {
  editingIds: string[] | null;
  setEditingIds: Function;
  restProps: any;
  setRowsData: Function;
};

const Actions: FC<ActionProps> = ({ editingIds, setEditingIds, restProps, setRowsData }) => {
  // DATA
  const restPropRow = restProps?.row;
  const updatedRow = restProps?.updatedRow;
  //REDUX
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [updatedRowData, setUpdatedRowData] = useState<any>({});

  // PAYLOAD
  const payload = {
    serviceId: restPropRow?.id,
    name: updatedRowData?.serviceName?.trim() || '',
    description: updatedRowData?.description?.trim() || '',
    price: Number(updatedRowData?.price?.replace('$', '')),
    duration: Number(updatedRowData?.duration?.replace('min', ''))
  };

  // UPDATE SERVICE
  const onClickToSave = async () => {
    setLoading(true);
    const data = await dispatch(updateUserServiceAPI({ ...payload }));
    if (data.meta.requestStatus === 'fulfilled') {
      setLoading(false);
      setEditingIds((prev: any) => prev?.filter((id: string) => id !== restPropRow?.id));
      setRowsData((prev: any) =>
        prev?.map((item: any) => (item?.id === restPropRow?.id ? updatedRowData : item))
      );
    }

    if (data.meta.requestStatus === 'rejected') {
      console.log('error', data);
      setLoading(false);
    }
  };

  useEffect(() => {
    setUpdatedRowData(updatedRow);
  }, [updatedRow]);

  return (
    <div className='flex justify-start items-center gap-2'>
      {editingIds?.includes(restProps?.row?.id) ? (
        <>
          <button
            onClick={onClickToSave}
            className='flex items-center justify-center bg-primary/60 hover:bg-primary text-white rounded-md p-1.5 transition-all duration-150 shadow-sm hover:shadow-md'
          >
            {loading ? (
              <span className='w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin' />
            ) : (
              <CheckSaveIcon className='size-4' />
            )}
          </button>
          <button
            onClick={() =>
              setEditingIds((prev: any) => prev?.filter((id: string) => id !== restProps?.row?.id))
            }
            className='flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md p-1.5 transition-all duration-150 shadow-sm hover:shadow-md'
          >
            <CrossIcon className='size-4' />
          </button>
        </>
      ) : (
        <button onClick={() => setEditingIds((prev: any) => [...prev, restProps?.row?.id])}>
          <EditPencilIcon className='size-4 ml-4' />
        </button>
      )}
    </div>
  );
};
